import { PropsWithChildren, useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { AppSidebar } from "@/components/app-sidebar"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { SiteHeader } from "@/components/site-header"
import { Toaster, toast } from 'sonner'
import { PageProps } from '@inertiajs/core'
import Layout from '@/layouts/Layout'

interface Flash {
  success?: string;
  alert?: string;
  notice?: string;
}

interface CustomPageProps extends PageProps {
  flash?: Flash;
}

export default function SidebarLayout({ children }: PropsWithChildren) {
  const { flash } = usePage<CustomPageProps>().props

  useEffect(() => {
    if (flash?.success) {
      toast.success(flash.success)
    }
    if (flash?.notice) {
      toast.info(flash.notice)
    }
    if (flash?.alert) {
      toast.error(flash.alert)
    }
  }, [flash])

  return (
    <Layout>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <SiteHeader />
          {children}
        </SidebarInset>
        <Toaster position="top-right" richColors />
      </SidebarProvider>
    </Layout>
  )
}

